<script lang="ts">
  import { onMount } from "svelte";
  import { watchGTM, watchPlausible } from "../support/analytics";

  export let gtmContainerId: string | null;
  export let plausibleDomain: string | null;

  onMount(function () {
    if (gtmContainerId) {
      watchGTM();
    }

    if (plausibleDomain) {
      watchPlausible(plausibleDomain);
    }
  });
</script>

<svelte:head>
  {#if gtmContainerId != null}
    <script async src="https://www.googletagmanager.com/gtm.js?id={gtmContainerId}">
    </script>
  {/if}
</svelte:head>
